import { TYPES } from "../actions/migrationContentAction.js";

const {
  API_REQUEST,
  API_ERROR,
  API_SUCCESS,
  CLEAR_ERROR,

  DELETE_MIGRATION_CONTENT,
  LIST_MIGRATION_CONTENT_SUCCESS,
} = TYPES;

const initialState = {
  loading: true,
  migrationContentError: "",
  migrationContents: [],
  error: false,
  msg: null,
};

const migrationContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERROR: {
      return {
        ...state,
        error: false,
        msg: null,
      };
    }

    case LIST_MIGRATION_CONTENT_SUCCESS: {
      return {
        ...state,
        migrationContents: action.data,
        loading: false,
      };
    }

    case DELETE_MIGRATION_CONTENT: {
      let migrationContents = [...state.migrationContents];

      return {
        ...state,
        migrationContents: migrationContents.filter((mc) => mc._id !== action.data),
        loading: false,
        msg: "Migration content deleted successfully",
      };
    }

    case API_REQUEST: {
      return { ...state, loading: true };
    }

    case API_ERROR: {
      return {
        ...state,
        migrationContentError: action.data,
        loading: false,
        error: true,
        msg: action.data,
      };
    }

    case API_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        msg: action.data || "Success",
      };
    }

    default: {
      return state;
    }
  }
};

export default migrationContentReducer;
